import { render, staticRenderFns } from "./_RobinHood.vue?vue&type=template&id=328a5abe&"
import script from "./_RobinHood.vue?vue&type=script&lang=js&"
export * from "./_RobinHood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports